import { useCallback} from "react";
import { useMutation } from "../base";
import globalState, { GlobalState } from "../../globalState";
import { updateUserMessagePreferences } from "../../api/usersApi";
import { useIntl } from "react-intl";
import messages from "./messages";
import { ChatUserData } from "myfitworld-model";

function useUpdateUserMessagePreferences({fetchAllChats} : {fetchAllChats: () => any}){

  const {formatMessage} = useIntl();
  const updateUserMessagePreferencesQuery = useCallback(async ({chatId, userFirstData, userSecondData}:{chatId?: string; userFirstData?: ChatUserData; userSecondData?: ChatUserData})=>{
    try {
      if(chatId && userFirstData && userSecondData){
        await updateUserMessagePreferences(chatId, userFirstData, userSecondData);
        await fetchAllChats();
      }
    } catch (error) {
      globalState.update((state:GlobalState)=>{
        state.toastQueue.push({
          message: formatMessage(messages.error_updating_archived_id),
          severity:"error"
        })
      }) 
      throw error
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const { status, error, isLoading } = useMutation(updateUserMessagePreferencesQuery);
  
  return {
    status,
    error,
    isLoading,
    updateUserMessagePreferences: updateUserMessagePreferencesQuery,
  };
}
export default useUpdateUserMessagePreferences;
